import React , {Component, Fragment} from 'react'
import { Table, Button, Select, Modal, Spin, message, Row, Col, Form, Input } from 'antd'
import Axios from 'axios'
import keys from '../../keys'
import * as titleActions from  '../../Actions/TitleActions'
import fetchVehicles from '../../redux/vehicles/actions/actionCreators'
import { connect } from 'react-redux'

const {confirm} = Modal

class ViewVehicles extends Component{


    state = {
        loading: false,
        vehicles : [],
        modal_visible : false,
    }

    componentDidMount() { 
        titleActions.changeTitle("View Vehicles")
        message.loading()
        this.props.fetchVehicles(
            this.props.entity.server
            ,
            ()=> {
                message.destroy()
                message.success("Vehicles fetched")
            }
            ,
            ()=>{
                message.destroy()
                message.error("Vehicles fetching failed")
            }
        )

        
    }

    editVehicle = (id) => {
        
        Axios.get(`${this.props.entity.server}/warehouse/vehicle/${id}`)
        .then(
            response => {
                this.setState({
                    id : id,
                    vehicle_no: response.data.vehicle_no,
                    name : response.data.name,
                    modal_visible:true,
                    edit:true
                })
            }
        )
        .catch(
            e => {
                message.error("Something when wrong!")
            }
        )

    }


    setWarehouseOptions = (data) =>{
        this.setState(
            {
                warehouses: data
            },() => console.log(this.state)
        )
    }

    formatTableData = () => {
        const data = this.props.vehicle.vehicles.filter( vehicle => vehicle.is_current)    
        return data.map(
            (vehicle, index) => {
                return {
                    key:index,
                    vehicle_no : vehicle.vehicle_no,
                    name : vehicle.name,
                    id:vehicle.id,
                    delete_id : vehicle.id
                }
            }
        )
    }


    showDeleteConfirm = (vehicle_id ) =>  {
        const deleteRequest = this.deleteVehicleRequest
        const fetchVehicles = () => this.props.fetchVehicles(this.props.entity.server)
        confirm({
          title: 'Are you sure delete this warehouse?',
          content: 'You can\'t delete this  if you have products in this!',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk() {
            deleteRequest(vehicle_id,
                ()=>{
                    message.success("Vehicle deleted successful")
                    fetchVehicles()
                },
                ()=>{
                    message.error("Vehicle delete failed")
                }    
                )
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }  


      deleteVehicleRequest = (vehicle_id,successCallback=()=>{},errorCallback=()=>{}) => {
            Axios.delete(
                `${this.props.entity.server}/warehouse/vehicle/${vehicle_id}`  
            )
            .then(
                result => {
                    successCallback()          
                }
            )
            .catch(
                err => {
                    console.log(err);
                      errorCallback()
                }
            )
        }
      

    columns = [
        {
            key: "no",
            dataIndex: "vehicle_no",
            title : "Vehicle No"
        }
        ,

        {
            key: "name",
            dataIndex: "name",
            title : "Name"
        },
        {
            key: "edit",
            dataIndex: "id",
            title : "",
            render : id => <Button onClick={()=>this.editVehicle(id)} >Edit</Button>
        },
        {
            key: "delete",
            dataIndex: "delete_id",
            title : "",
            render: (id) => <Button type="danger" onClick={() => this.showDeleteConfirm(id)}  >Delete</Button>
        }

    ]

    addNewVehicleRequest = (server,data,successCallback=()=>{},errorCallback=()=>{}) => {
        Axios.post(
            `${server}/warehouse/stock-vehicles/`,data
        )
        .then(
            result => {
                successCallback()
            }
        )
        .catch(
            err => {
                errorCallback()
            }
        )

    }

   
    editVehicleRequest = (id, successCallback=()=>{},errorCallback=()=>{}) =>{
        Axios.patch(
            `${this.props.entity.server}/warehouse/vehicle/${id}`,{
                name : this.state.name ,
                vehicle_no: this.state.vehicle_no
            }
        ).then(
            response =>{
                message.success("Vehicle updated")
                successCallback()
            }
        )
        .catch(
            error => {
                message.error("Vehicle update failed")
            }
        )
    }


    handleOk = () => {
        if (this.state.edit){
            this.editVehicleRequest(this.state.id,
            ()=>{     
                this.setState({
                    edit:false,
                    loading:false,
                    id:null,
                    vehicle_no:null, 
                    name:null
                })
                this.props.fetchVehicles( this.props.entity.server,
                    ()=> {
                        message.destroy()
                        message.success("Vehicles fetched")
                    }
                    ,
                    ()=>{
                        message.destroy()
                        message.error("Vehicles fetching failed")
                    }
                )
            })
            return
        }

        this.setState({
            loading:true
        })

       this.addNewVehicleRequest(this.props.entity.server,
        {
            vehicle_no:this.state.vehicle_no,
            entity:this.state.entity,
            name: this.state.name,
            is_current:true
        }
        , 
        () => {
            message.success("Vehicle added successfully")
            this.setState({loading:false,modal_visible:false})
            this.props.fetchVehicles(
                this.props.entity.server
                ,
                ()=> {
                    message.destroy()
                    message.success("Vehicles fetched")
                }
                ,
                ()=>{
                    message.destroy()
                    message.error("Vehicles fetching failed")
                }
            )
        }
        ,
        () => {
            message.error("Vehicle addeding failed")
            this.setState({loading:false})
        }
        )
    }


    handleCancel = () => {
        this.setState({
            modal_visible:false,
            name : null,
            entity:null,
            vehicle_no:null
        })
    }

    handleSubmit = (e) =>{
        e.preventDefault()
    }


    render(){

      return (

       <Spin spinning={this.state.loading} > 
        <Row>
            <Col offset={20} span={4}> 
                <Button htmlType="button" type= "primary" onClick={(e)=> this.setState({modal_visible:true})}> Add New Vehicle</Button>  
            </Col>
        </Row>     
        <Table 
            dataSource = {this.formatTableData()}  
            columns= {this.columns}/> 
        <Form onSubmit={this.handleSubmit}>
        <Modal
            title="New Vehicle"
            visible={this.state.modal_visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}

            footer={[
                <Button key="back" onClick={this.handleCancel}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" htmlType="submit" loading={this.state.loading} onClick={this.handleOk}>
                  {this.state.edit ? "Edit Vehicle" : "Add Vehicle"}
                </Button>,
              ]}
            >
                <Form.Item label="Vehicle No">
                    <Input required onChange={(e) => this.setState({vehicle_no:e.target.value})} value={this.state.vehicle_no}></Input>
                </Form.Item>
                <Form.Item label="Vehicle Name">
                    <Input required onChange={(e) => this.setState({name:e.target.value})} value={this.state.name}></Input>
                </Form.Item>
                {/*     */}
            </Modal>   
            </Form>
      
      </Spin>   
      
      )

    }

}

const mapStateToProps = state => (
    {
        vehicle:state.vehicle,
        entity : state.entity,
        
    }
)

const mapDispatchToProps = dispatch => ({
    fetchVehicles: (server,successCallback,errorCallback) => dispatch(fetchVehicles(server,{},successCallback,errorCallback))
})


export default connect(mapStateToProps,mapDispatchToProps)(ViewVehicles)